class MonthlySummary {
    numberOfBricks;
    initialInvestmentAmount;
    investmentValue;
    fiscalRegime;
    estimatedLeasing;
    fees;
    incomeTaxes;
    capitalGain;
    vatWithheld;
    profits;
    annualEstimatedLeasing;
    constructor(data) {
        this.numberOfBricks = data.numberOfBricks;
        this.initialInvestmentAmount = data.initialInvestmentAmount;
        this.investmentValue = data.investmentValue;
        this.fiscalRegime = data.fiscalRegime;
        this.estimatedLeasing = data.estimatedLeasing;
        this.fees = data.fees;
        this.incomeTaxes = data.incomeTaxes;
        this.capitalGain = data.capitalGain;
        this.vatWithheld = data.vatWithheld;
        this.profits = data.profits;
        this.annualEstimatedLeasing = data.annualEstimatedLeasing;
    }
}
export default MonthlySummary;
